import { isEmpty, mergeDeepLeft } from "ramda";

import { htmlCodeGenerators } from "./html";
import { reactCodeGenerators } from "./react";

import { DEFAULT_CUSTOMIZATION, SWITCH_OPTIONS } from "../constants";

export const buildQueryParams = (
  customization = {},
  existingQueryParams = {}
) => {
  const activeOptions = Object.keys(SWITCH_OPTIONS).reduce((acc, key) => {
    const value = customization[key]?.value;
    if (value) acc[key] = value;

    return acc;
  }, {});

  const mergedQueryParams = { ...existingQueryParams, ...activeOptions };
  if (isEmpty(mergedQueryParams)) return "";

  return JSON.stringify(mergedQueryParams, null, 2)
    .replace(/\n/g, " ")
    .replace(/\s\s+/g, " ");
};

export const generateCode = options => {
  const { selectedLanguage, type, ...embeddedCodeOptions } = options;

  const queryParams = embeddedCodeOptions.customization?.queryParams || {};
  const customization = embeddedCodeOptions.customization || {};

  const codeOptions = {
    ...embeddedCodeOptions,
    queryParams: buildQueryParams(customization, queryParams),
  };

  return selectedLanguage === "react"
    ? reactCodeGenerators[type]?.(codeOptions)
    : htmlCodeGenerators[type]?.(codeOptions);
};

export const buildDefaultCustomization = defaultCustomizations =>
  mergeDeepLeft(defaultCustomizations, DEFAULT_CUSTOMIZATION);

export const buildQueryParamsFromInputFields = inputFields => {
  const filteredInputFields = inputFields.filter(
    ({ name, value }) => name && value
  );

  return filteredInputFields.reduce((queryParams, { name, value }) => {
    queryParams[name] = value;

    return queryParams;
  }, {});
};

export const toCamelCasedString = string =>
  string?.replace(/[_-]+(\w)/g, (_, nextChar) => nextChar.toUpperCase());

export const buildIframeURL = ({ id, iframeUrl, queryParams }) => {
  const url = new URL(iframeUrl || `${location.origin}/embed/${id}`);

  if (!queryParams) return url.toString();

  const parsedQueryParams = JSON.parse(queryParams);
  Object.entries(parsedQueryParams).forEach(([key, value]) => {
    url.searchParams.append(key, value);
  });

  return url.toString();
};

export const removeHeightFromStyle = style =>
  style.replace(/height\s*:\s*[^;]+;?\s*/g, "").trim();
